/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContainerCreateRequest } from '../../models/container-create-request';
import { ContainerCreateResponse } from '../../models/container-create-response';

export interface CreateContainer$Params {
      body: ContainerCreateRequest
}

export function createContainer(http: HttpClient, rootUrl: string, params: CreateContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createContainer.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerCreateResponse>;
    })
  );
}

createContainer.PATH = '/containers';
